import styled, { createGlobalStyle } from "styled-components";
import Footer from "../components/Footer";

import { spacing } from "@material-ui/system";
import {
    CssBaseline,
    Paper as MuiPaper,
    withWidth,
    Theme,
} from "@material-ui/core";

import { isWidthUp } from "@material-ui/core/withWidth";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${({ theme }: { theme: Theme }) =>
        theme.palette.background.default};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
    display: flex;
    min-height: 100vh;
`;

const AppContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
    flex: 1;
    background: ${(props) => props.theme.palette.background.default};

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        flex: none;
    }

    .MuiPaper-root .MuiPaper-root {
        box-shadow: none;
    }
`;

const Dashboard = ({
    children,
    width,
}: {
    children: any;
    width: Breakpoint;
}) => {
    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            <AppContent>
                <MainContent p={isWidthUp("lg", width) ? 12 : 5}>
                    {children}
                </MainContent>
                <Footer />
            </AppContent>
        </Root>
    );
};

export default withWidth()(Dashboard);
